import bem from "easy-bem";
import React from "react";

import "./MaintenanceScreen.css";

const cn = bem("maintenance-screen");

const MaintenanceScreen: React.FC = () => (
  <div className={cn()}>
    <div className={cn("content")}>
      <div className={cn("icon")}>🛠</div>
      <h1 className={cn("title")}>Сайт временно недоступен</h1>
      <p className={cn("message")}>Идут технические работы, скоро вернёмся</p>
    </div>
  </div>
);

export default MaintenanceScreen;
